module.exports = __webpack_public_path__ + "images/HaulerW231.d3e3ab0311c3aa0b20143b9934c5ce26.png";